import { render, staticRenderFns } from "./BeefTagsModal.Style#Drawer.vue?vue&type=template&id=438687b3&scoped=true"
import script from "./BeefTagsModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./BeefTagsModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./BeefTagsModal.Style#Drawer.vue?vue&type=style&index=0&id=438687b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438687b3",
  null
  
)

export default component.exports